import { render, staticRenderFns } from "./WxShareTips.vue?vue&type=template&id=0e79713c&"
import script from "./WxShareTips.vue?vue&type=script&lang=js&"
export * from "./WxShareTips.vue?vue&type=script&lang=js&"
import style0 from "./WxShareTips.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports